<template>
  <v-menu
    :close-on-content-click="false"
    max-height="85%"
    offset-y
  >
    <template #activator="{on}">
      <v-text-field
        readonly
        :label="label"
        :value="displayValue"
        :hint="counterVal"
        :error-messages="errorMessages"
        persistent-hint
        v-on="on"
      />
    </template>

    <v-list class="pt-0">
      <v-sheet
        class="list-item-sticky text-center text-body-2 text--secondary"
      >
        <p class="mb-0">
          {{ $t('label.selection_x', [$t('label.x_seats', [selectedSeats])]) }}
        </p>
        <v-divider />
      </v-sheet>

      <template v-for="(val, key) in groupedTabItems">
        <v-subheader :key="key">
          {{ $t('label.x_seats', [key]) }}
        </v-subheader>
        <v-divider :key="`${key}_divider`" />
        <v-list-item
          v-for="(tabItem, j) in val"
          :key="`${key}_${j}`"
          inactive
          @click.stop="toggleCheckbox(tabItem)"
        >
          <v-list-item-action class="mr-3">
            <v-checkbox
              v-model="selection"
              :value="tabItem"
              :value-comparator="checkboxComparator"
              @click="toggleCheckbox(tabItem)"
            />
          </v-list-item-action>
          <v-list-item-title>
            {{ tabItem.no }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import TabItem from '@/model/TabItem';

export default Vue.extend({
  name: 'TabItemAllocationRow',
  components: { },
  props: {
    tabItems: { type: Array as PropType<Array<TabItem>>, required: true },
    value: { type: Array as PropType<Array<TabItem>>, required: true },
    // partySize: { type: Number, required: true },
    // isError: { type: Boolean, required: false },
    label: { type: String, required: false, default: '' },
    errorMessages: { type: Array as PropType<Array<String>>, required: false, default: () => [] },
  },
  data() {
    return {
      selection: this.value as TabItem[],
      groupedTabItems: {} as any,
    };
  },
  computed: {
    displayValue(): string | null {
      if (this.selection.length === 0) { return null; }
      return `${this.$i18n.t('label.table', [''])}${this.selection.map(((e) => e.no)).join('+')}`;
    },
    counterVal(): string {
      return this.$i18n.t('label.x_seats', [this.selectedSeats]) as string;
    },
    selectedSeats(): number {
      return this.selection.map(((o) => o.seats)).reduce((a, b) => a + b, 0);
    },
    // enoughSeatsSelected(): boolean {
    //   return this.selectedSeats >= this.partySize;
    // },
  },
  watch: {
    value() {
      this.selection = this.value;
    },
  },
  mounted() {
    this.groupTabItems();
  },
  methods: {
    groupTabItems() {
      this.groupedTabItems = {};

      this.tabItems.forEach((tabItem) => {
        if (tabItem.seats in this.groupedTabItems) {
          this.groupedTabItems[tabItem.seats].push(tabItem);
        } else {
          Vue.set(this.groupedTabItems, tabItem.seats, [tabItem]);
        }
      });
    },
    checkboxComparator(lhs: TabItem, rhs: TabItem):boolean {
      return lhs.id === rhs.id;
    },
    toggleCheckbox(tabItem: TabItem) {
      if (this.selection.find((o) => o.id === tabItem.id)) {
        this.selection.splice(this.selection.findIndex((v) => v.id === tabItem.id), 1);
      } else {
        this.selection.push(tabItem);
      }
      this.selection.sort((o1, o2) => o1.order - o2.order);
      this.$emit('input', this.selection);
    },
  },
});
</script>

<style scoped lang="scss">
  .has-error ::v-deep(.v-text-field__slot input) {
    color: $danger-color !important;
  }
  .list-item-sticky {
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    z-index: 2;
    height: 48px;
  }

  .list-item-sticky ::v-deep(p) {
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
</style>
